import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { useState } from "react";
import StyledModalFooter from "@coworker/apprestructured/src/task-management/components/StyledModalFooter/StyledModalFooter";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { useTranslation } from "react-i18next";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";

interface MultipleArticlesWithActionsModalProps {
  content: React.ReactNode;
  showModal: boolean;
  handleCloseModal: () => void;
  handleConfirm: () => void;
  title?: string;
}

export const MultipleArticlesWithActionsModal = ({
  content,
  showModal,
  handleCloseModal,
  handleConfirm,
  title,
}: MultipleArticlesWithActionsModalProps) => {
  const { t } = useTranslation();
  return (
    <FixaModal visible={showModal} handleCloseBtn={handleCloseModal}>
      <FixaSheets
        labelledById="multiple-articles-with-actions"
        fullSize
        header={
          <FixaModalHeader
            id="task-management-articles-with-quantity-header"
            closeBtnClick={handleCloseModal}
            title={title}
          />
        }
        footer={
          <StyledModalFooter>
            <FixaButton
              text={t("confirmString")}
              type="primary"
              onClick={handleConfirm}
            />
          </StyledModalFooter>
        }
      >
        <FixaModalBody>{content}</FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
};
